import React from 'react';
import { PesquisaScorpion, FiltroStringScorpion } from 'scorpion-core'

class DinamicCrudCustomPesquisa extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.listar(this.props.customForm);
    }

    render() {
        const { colunas, titulo, listaPesquisa, loading } = this.props;
        let filtros = []
        if (colunas)
            colunas.forEach(col => {
                if (col.filtro) {
                    filtros.push(<FiltroStringScorpion key={col.id} name={"filtro" + col.id} label={col.label}
                        strComparaLike={item => col.getValue(item) + ""}
                        criaSugestaoPorLike={listaPesquisa} />)
                }
            });

        let listaDados = listaPesquisa;

        return (<div>
            <PesquisaScorpion
                titulo={titulo ? titulo : "Pesquisa de "}
                columns={colunas}
                data={listaDados}
                getID={(item, index) => item.uid ? item.uid : index}
                porPagina={10}
                loadingPesquisa={loading}
                botaoCadastrar={this.handleClickOpen}
                handleSubmit={this.props.handleSubmit}
                selecionar={this.props.selecionar}
                actionclose={this.props.actionclose}
            >
                {filtros}
            </PesquisaScorpion>

        </div>
        )
    }
}
export default DinamicCrudCustomPesquisa;




// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomPesquisa/DinamicCrudCustomPesquisa.js